import { render, staticRenderFns } from "./InviteAlert.vue?vue&type=template&id=52f233c2"
import script from "./InviteAlert.vue?vue&type=script&lang=js"
export * from "./InviteAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports